import { Injectable } from '@angular/core'
import { CurrentUser } from './common/models/current-user'

@Injectable()
export class PortalGlobals {
    org = 'ssi'

    // these values are set upon login.
    insuranceCoOrgID: number
    currentUser: CurrentUser
    selectedPlanYear: number
    availablePlanYears: number[]

    // These are the constant values which we can use in the application everywhere. These going to be update every year for AEP
    AEPPlanYearValue: string = '2019'
    //PreviousPlanYearValue: string = '2018'

    insuranceCompanyNameSSI: string = 'SilverScript Insurance Company'
    insuranceCompanyNameNEJE: string = 'Blue MedicareRx (PDP)'
    insuranceCompanyNameAetna: string = 'Aetna'
    insCompanyNameAetna: string = 'Aetna Insurance Company'
    insCompanyNameSSI: string = 'SilverScript'
    insCompanyNameAetnaMedicare: string = 'Aetna Medicare'
    insCompanyNameAetnaPdp: string = 'Aetna PDP'

    TrainingPlanYear = '2020'
    Planyear2023: number = 2023 //Dont update
    Planyear2024: number = 2024 //Dont update
    Planyear2025: number = 2025 //Dont update
    Planyear2026: number = 2026 //Dont update

    PreviousPlanYear = 2023
    NextYearAEP = 2021 //Dont update
    CurrentYear = 2020 //Dont update

    // Display Plus for AK from 2022
    FromYear = 2022 //Dont update

    EnrollmentGenderEndDate = '05/01/2025'
}
